<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
    <div
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-standard-portrait-page':'a4-standard-landscape-page':field.temp_prop.paper_size==1?field.temp_prop.orientation==0?'a5-standard-portrait-page':'a5-standard-landscape-page':''"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    
    >
      <div class="print-template"   :style="{'font-size':(field.temp_prop.font_size||8)+'pt !important','color':(field.temp_prop.font_color.hex||'#000'),'background':(field.temp_prop.bg_color.show&&field.temp_prop.bg_color.value.hex||'#000')}">
        <!-- Header margin top value as height -->
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <!-- Page Heading -->
          <h5
            v-if="field.header_prop.show_doc_title"
            :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
            class="text-center invoice-top-heading"
            style="position:relative"
          >
            {{list.invoice_header_detail.inv_type==1?field.header_prop.doc_title:'Bill of Supply'}}
            <span
              v-show="showprintlabel && printlabel != ''"
              style="position:absolute;right:0;padding:2px 4px;border:2px solid #929292;color:#000;margin-right:5px"
            >{{ printlabel }}</span>
          </h5>

          <!-- First Block -->
          <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div style="width:30% !important;word-break:break-word">
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                style="margin-bottom:1px;font-weight:500;"
              >{{ org_details.comp_name }}</div>

              <div v-if="field.header_prop.show_org_addr" class="custom-invoice-address" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">
                <p>{{ org_details.addr_line_1 }}</p>
                <p>{{ org_details.addr_line_2 }}</p>
                <p>{{ org_details.org_city }} {{ getDetails($AppDetails.state_details,org_details.org_state,'state_name') }}</p>
                <p>
                  {{ getDetails($AppDetails.country_details,org_details.org_country,'country_name') }}
                  {{ org_details.org_pincode }}
                </p>
                <p>{{field.header_prop.phone}}: {{ org_details.phone_no }}</p>
                <p v-if="field.header_prop.hasOwnProperty('fax')&&org_details.hasOwnProperty('fax_no')">{{field.header_prop.fax}}: {{org_details.fax_no}}</p>
                <p class="mb-0" href="mailto:#">{{ org_details.org_mail }}</p>
                <p
                  v-if="org_details.gst_type != 3 && org_details.gst_no != ''"
                  style="margin-bottom:0px;"
                >GSTIN: {{ org_details.gst_no }}</p>
              </div>
            </div>
            <div v-if="field.header_prop.show_status_stamp">
              <span
                class="stamp is-approved"
                :style="'color: ' + (list.invoice_amount_detail.inv_status == 1 ? '#4f5cab' :  list.invoice_amount_detail.inv_status == 2 ?'#4e98ff': list.invoice_amount_detail.inv_status == 5 ? '#f9962d':list.invoice_amount_detail.inv_status == 6 ? '#0A9928': 'red')+';border: 0.2rem solid ' + (list.invoice_amount_detail.inv_status == 1 ? '#4f5cab' :  list.invoice_amount_detail.inv_status == 2 ?'#4e98ff': list.invoice_amount_detail.inv_status == 5 ? '#f9962d':list.invoice_amount_detail.inv_status == 6 ? '#0A9928': '')"
              >{{ list.invoice_amount_detail.inv_status_name }}</span>
            </div>
            <!-- Organization Logo -->
            <div>
              <!-- Max width for Logo Block -->

              <!-- Logo Image -->
              <img
                v-if="field.header_prop.show_logo && org_details.org_logo != null && org_details.org_logo  != ''"
                v-bind:src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
                style="max-width:300px;max-height:183.05px;padding-bottom:5px !important"
              />
            </div>
          </div>
          <!-- End of First Block -->
          <div style="border-top:1px solid #ededed;margin-bottom:5px;"></div>
          <!-- Second Block -->
          <div class="invoice-second-block" style="display:flow-root">
            <div style="display:flex;justify-content: space-between;" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
              <!-- Bill Address -->
              <div
                v-if="field.header_prop.doc_bill_to.show"
                style="width:30% !important;word-break:break-word"
              >
                <div
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                   style="margin-bottom:1px;font-weight:500;word-break: break-word !important;width:180px !important"
                >{{field.header_prop.doc_bill_to.label}}</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;"
                >{{ list.invoice_header_detail.cus_name }}</div>

                <div class="custom-invoice-address">
                  <p>{{ list.invoice_header_address_detail[1].cus_addr_line_1 }}</p>
                  <p>{{ list.invoice_header_address_detail[1].cus_addr_line_2 }}</p>
                  <p>{{ list.invoice_header_address_detail[1].cus_city }} {{ getDetails($AppDetails.state_details,list.invoice_header_address_detail[1].cus_state,'state_name') }}</p>

                  <p>{{ getDetails($AppDetails.country_details,list.invoice_header_address_detail[1].cus_country,'country_name') }} {{ list.invoice_header_address_detail[1].cus_pincode }}</p>
                  <p>{{ list.invoice_header_detail.cus_mail }}</p>
                  <p>
                    <span>Ph:</span>
                    {{ list.invoice_header_detail.cus_ph_no_1 }}
                  </p>
                  <p
                    v-if="(list.invoice_header_detail.cus_gst_type != 3 && list.invoice_header_detail.cus_gst_type != 5 && list.invoice_header_detail.cus_gst_type != 6) && list.invoice_header_detail.cus_gst_type != 0"
                  >
                    <span>GSTIN:</span>
                    {{ list.invoice_header_detail.cus_gst_no }}
                  </p>
                </div>
              </div>
              <!-- Shipping Address -->
              <div
                v-if="field.header_prop.doc_ship_to.show"
                style="width:30% !important;word-break:break-word"
              >
                <div
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                 style="margin-bottom:1px;font-weight:500;word-break: break-word !important;width:180px !important"
                >{{field.header_prop.doc_ship_to.label}}</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;"
                >{{ list.invoice_header_detail.cus_name }}</div>

                <div class="custom-invoice-address">
                  <p>{{ list.invoice_header_address_detail[2].cus_addr_line_1 }}</p>
                  <p>{{ list.invoice_header_address_detail[2].cus_addr_line_2 }}</p>
                  <p>{{ list.invoice_header_address_detail[2].cus_city }} {{ getDetails($AppDetails.state_details,list.invoice_header_address_detail[2].cus_state,'state_name') }}</p>

                  <p>{{ getDetails($AppDetails.country_details,list.invoice_header_address_detail[2].cus_country,'country_name') }} {{ list.invoice_header_address_detail[2].cus_pincode }}</p>
                </div>
              </div>
              <!-- Invoice Details-->
              <div>
                <div
                :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  style="margin-bottom:1px;font-weight:500;text-align:right;word-break:break-word"
                ><span v-if="field.header_prop.hasOwnProperty('doc_no')&&field.header_prop.doc_no.show">{{field.header_prop.doc_no.label}} : </span>{{ list.financial_year }}/{{ list.invoice_header_detail.inv_no}}</div>

                <table class="custom-invoice-details-table" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
                  <tbody>
                    <tr v-if="field.header_prop.doc_date.show">
                      <td
                      style="word-break:break-word"
                      :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                      >{{list.invoice_header_detail.inv_type==1?field.header_prop.doc_date.label:'Bill of Supply Date'}} : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                       style="word-break:break-word"
                        class="text-right"
                      >{{getDateFormat(list.invoice_header_detail.created_date)}}</td>
                    </tr>
                    <tr
                      v-if="field.header_prop.doc_due_date.show && list.invoice_header_detail.due_date != '' && list.invoice_header_detail.due_date != null"
                    >
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold"  style="word-break:break-word">{{field.header_prop.doc_due_date.label}} : </td>
                      <td class="text-right"  style="word-break:break-word"  :style="{'color':(field.temp_prop.font_color.hex||'#000')}">{{getDateFormat(list.invoice_header_detail.due_date)}}</td>
                    </tr>
                    <tr
                      v-if="field.header_prop.doc_ref_no.show && list.invoice_header_detail.ref_no != null && list.invoice_header_detail.ref_no != ''"
                    >
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold"  style="word-break:break-word">{{field.header_prop.doc_ref_no.label}} : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-right"
                        style="word-break:break-word !important;width:150px !important"
                      >{{ list.invoice_header_detail.ref_no }}</td>
                    </tr>
                    <tr v-if="field.header_prop.doc_place_supply.show">
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold"  style="word-break:break-word">{{field.header_prop.doc_place_supply.label}} : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-right"
                        style="word-break:break-word !important;width:150px !important"
                      >{{ $AppDetails.state_details[list.invoice_header_detail.place_of_supply].state_name }}({{ $AppDetails.state_details[list.invoice_header_detail.place_of_supply].state_id }})</td>
                    </tr>
                    <tr v-if="field.header_prop.doc_sales_person.show">
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold"  style="word-break:break-word">{{field.header_prop.doc_sales_person.label}} : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-right"
                        style="word-break:break-word !important;width:150px !important"
                      >{{ list.invoice_header_detail.sales_person_name }}</td>
                    </tr>
                    <tr v-if="field.header_prop.hasOwnProperty('doc_proj_name')&&field.header_prop.doc_proj_name.show">
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold"  style="word-break:break-word">{{field.header_prop.doc_proj_name.label}} : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-right"
                        style="word-break:break-word !important;width:150px !important"
                      >{{ list.invoice_header_detail.proj_name||'' }}</td>
                    </tr>
                    <tr v-if="field.header_prop.payment_terms.show">
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold"  style="word-break:break-word">{{field.header_prop.payment_terms.label}} : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-right"
                        style="word-break:break-word !important;width:150px !important"
                      >{{ list.invoice_header_detail.term_name }}</td>
                    </tr>
                     <tr v-if="field.header_prop.hasOwnProperty('doc_eway_no')&&field.header_prop.doc_eway_no.show">
                      <td
                      :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                         style="word-break:break-word"
                      >{{field.header_prop.doc_eway_no.label}} : </td>
                      <td    :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                      class="text-right"
                        style="word-break:break-word !important;width:150px !important"
                        >{{list.invoice_header_detail.eway_bill_no}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--End of Second Block -->
          <div style="justify-content: space-between;margin-top:10px;margin-bottom:5px;" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <b-row>
              <b-col
                cols="3"
                v-for="custom_field in inv_settings_details.custom_field"
                v-if="custom_field.print_show == 1 && custom_field.permissions != 'hide' && list.invoice_header_detail[custom_field.field_name] && custom_field.status == 1"
                :key="custom_field.index"
              >
                <div>
                  <span :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold">{{custom_field.label_name}} : </span>

                  <span  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                    class="text-left"
                    v-if="custom_field.datatype == 'select'"
                    style="word-break:break-word !important;width:150px !important"
                  > {{ getJsonPresentValue(custom_field.options,'value',list.invoice_header_detail[custom_field.field_name],'label') }}</span>
                  <span  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                   style="word-break:break-word"
                    class="text-left"
                    v-else-if="custom_field.datatype == 'date'"
                  > {{ getDateFormat(list.invoice_header_detail[custom_field.field_name]) }}</span>
                  <span  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                   style="word-break:break-word"
                    class="text-left"
                    v-else-if="custom_field.datatype == 'amount'"
                  > {{ orgCurrencySymbol +' '+list.invoice_header_detail[custom_field.field_name] }}</span>
                  <span
 :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                    class="text-left"
                    v-else
                    style="word-break:break-word !important;width:150px !important"
                  > {{ list.invoice_header_detail[custom_field.field_name] }}</span>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- Third Block -->
          <div
            class="invoice-third-block"
            style="display:flow-root;border-top:1px solid #ededed;"
            v-if="list.invoice_header_detail.is_export==2"
            :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
          >
            <div style="display:flex;justify-content: space-between;margin-top:5px;">
              <div>
                <table class="custom-invoice-details-table" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
                  <tbody>
                    <tr v-if="list.invoice_header_detail.country_of_supply">
                      <td
                      :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                        style="padding-right:10px !important; word-break:break-word"
                      >Country of Supply : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-left"
                        style="word-break:break-word"
                      >{{ $AppDetails.country_details[list.invoice_header_detail.country_of_supply].country_name }}({{ $AppDetails.country_details[list.invoice_header_detail.country_of_supply].country_id }})</td>
                    </tr>
                    <tr>
                      <td
                      :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                        style="padding-right:10px !important;word-break:break-word"
                      >Export Type : </td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-left"
                        style="word-break:break-word"
                      >{{ list.invoice_header_detail.export_type }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <table class="shipping-details-table" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
                  <tbody>
                    <tr>
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word" class="text-left semi-bold">Shipping Bill No.</td>
                      <td class="text-left" style="word-break:break-word">: {{ list.invoice_header_detail.shipping_bill_number }}</td>
                    </tr>
                    <tr>
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold" style="word-break:break-word">Shipping Bill Date</td>
                      <td  :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-left" style="word-break:break-word"
                      >: {{getDateFormat(list.invoice_header_detail.shipping_bill_date)}}</td>
                    </tr>
                    <tr>
                      <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold" style="word-break:break-word">Shipping Port No.</td>
                      <td class="text-left" style="word-break:break-word"  :style="{'color':(field.temp_prop.font_color.hex||'#000')}">: {{ list.invoice_header_detail.shipping_port_code }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- End of Third Block -->
          <div
            style="border-top:1px solid #ededed;margin-top:5px;"
            v-if="list.invoice_header_detail.is_export==2"
            :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
          ></div>
          <!-- Fourth Block-->
          <div
            v-if="field.header_prop.doc_inv_tag.show && inv_settings_details.inv_tags_on_print"
            class="invoice-fourth-block"
            style="margin-top:5px;"
            :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
          >
            <table class="custom-invoice-details-table" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
              <tbody>
                <tr>
                  <td
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                    class="text-left semi-bold label-invoice-tag"
                    style="padding-right:10px !important;word-break:break-word"
                  >{{list.invoice_header_detail.inv_type==1?field.header_prop.doc_inv_tag.label:'Bill of supply Tags'}} </td>
                  <td class="text-left" style="word-break:break-word"  :style="{'color':(field.temp_prop.font_color.hex||'#000')}">: {{ list.inv_tags }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of Fourth Block -->
          <!-- Fifth Block -->
          <div class="invoice-fifth-block" style="margin-top:15px;" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <table class="custom-invoice-line-item-table">
              <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
              >
                <th
                style="word-break: break-word !important"
                  v-if="field.item_prop.label.item_no.show"
                  :style="{'width':field.item_prop.label.item_no.width+'%'}"
                  class="text-right semi-bold"
                >{{field.item_prop.label.item_no.label}}</th>
                <th
                style="word-break: break-word !important"
                  :style="{'width':(field.item_prop.label.item.show?field.item_prop.label.item.width:field.item_prop.label.desc.width)+'%'}"
                  v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                  class="text-left semi-bold"
                >
                <template v-if="field.item_prop.label.item.show">
                  {{field.item_prop.label.item.label+(field.item_prop.label.desc.show?field.item_prop.label.desc.label?(' & '+field.item_prop.label.desc.label):'& Description':'')}}
                </template>
                <template v-else>
                  {{field.item_prop.label.desc.label}}
                </template>
                </th>
                 <th
                 style="word-break: break-word !important"
                v-for="(custom,index) in pdt_settings_details.custom_field.filter(x=>x.print_show==1)"
                :key="index"
                  :style="{'width':field.item_prop.label.custom_field.width+'%'}"
                  class="text-left semi-bold"
                  v-if="field.item_prop.label.custom_field.show"
                >{{custom.label_name}}</th>
                <th
                style="word-break: break-word !important"
                  :style="{'width':field.item_prop.label.hsn.width+'%'}"
                  v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                  class="semi-bold"
                >{{field.item_prop.label.hsn.label}}</th>
                <th
                style="word-break: break-word !important"
                  :style="{'width':field.item_prop.label.qty.width+'%'}"
                  v-if="field.item_prop.label.qty.show"
                  class="text-right semi-bold"
                >{{field.item_prop.label.qty.label}}</th>
                <th
                style="word-break: break-word !important"
                  :style="{'width':field.item_prop.label.rate.width+'%'}"
                  v-if="field.item_prop.label.rate.show"
                  class="text-right semi-bold"
                >{{field.item_prop.label.rate.label}}</th>
                <th
                style="word-break: break-word !important"
                  v-if="field.item_prop.label.discount.show && list.invoice_header_detail.discount_cat == 1"
                  :style="{'width':field.item_prop.label.discount.width+'%'}"
                  class="text-right semi-bold"
                >{{field.item_prop.label.discount.label}}</th>
                <th
                style="word-break: break-word !important"
                 v-for="(tax_split,tax_index) in list.tax_split"
                :key="tax_index"
                  :style="{'width':(field.item_prop.label.tax.show?field.item_prop.label.tax.width:field.item_prop.label.tax_amt.width)+'%'}"
                  v-if="(field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show) && org_details.gst_type == 1&&list.invoice_header_detail.inv_type!='2'"
                  class="text-right semi-bold"
                >{{tax_split.tax_name}}</th>
                <th
                style="word-break: break-word !important;min-width:80px"
                  :style="{'width':field.item_prop.label.amt.width+'%'}"
                  v-if="field.item_prop.label.amt.show"
                  class="text-right semi-bold"
                >{{field.item_prop.label.amt.label}}</th>
              </thead>
              <tbody  :style="{'font-size':(field.item_prop.layout.item_row_font_size||8)+'pt','color':(field.item_prop.layout.item_row_font_color.hex||'#000'),'background':(field.item_prop.layout.item_row_bg_color.show&&field.item_prop.layout.item_row_bg_color.value.hex||'#fff')}">
                <tr v-for="(item,index) in list.invoice_item_detail" :key="index">
                  <td
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.item_no.show" 
                    class="text-right"
                    style="vertical-align:top !important;display:table-cell !important"
                  >{{ index + 1 }}</td>
                  <td
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >
                   <span v-if="field.item_prop.label.item.show"> {{ item.pdt_name }}</span>
                    <span
                    v-if="field.item_prop.label.desc.show"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break:break-word"
                    >{{ item.pdt_desc }}</span>
                    <span
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt'}"
                      style="display:block"
                    >HSN/SAC Code : {{ item.pdt_hsn }}</span>
                  </td>
                   <td
                v-for="(custom,index) in pdt_settings_details.custom_field.filter(x=>x.print_show==1)"
                :key="index"
                  class="text-left semi-bold"
                  v-if="field.item_prop.label.custom_field.show"
                   :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                >{{item[custom.field_name]}}</td>
                   <td
                   v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{ item.pdt_hsn }}
                   
                  </td>
                  <td
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >
                    {{ item.pdt_qty }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-word"
                      v-if="field.item_prop.label.qty.show_unit"
                    >{{ item.unit_name }}</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >{{ parseFloat(item.unit_price) }}</td>
                  <td
                    v-if="field.item_prop.label.discount.show && list.invoice_header_detail.discount_cat == 1"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >{{ parseFloat(item.inv_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                  v-for="(tax_split,tax_index) in item.tax_type_details"
                  :key="tax_index"
                    v-if="(field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show) && org_details.gst_type == 1&&list.invoice_header_detail.inv_type!='2'"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  ><span  style="display:block"  v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show">{{tax_split.tax_amount?parseFloat(tax_split.tax_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }):'-'}}</span>
                  <span v-if="field.item_prop.label.tax.show" :style="{'border-bottom':field.item_prop.layout.item_font_color.hex,'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"> {{ tax_split.value?item.tax_name != null ? parseFloat(tax_split.value)+'%' : '0%':'-' }}</span></td>
                   
                  <td
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.amt.show && list.invoice_header_detail.tax_type_id == 1 && list.invoice_header_detail.discount_cat == 1"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >{{ parseFloat(item.inv_subtotal).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-else-if="field.item_prop.label.amt.show && list.invoice_header_detail.tax_type_id == 2 && list.invoice_header_detail.discount_cat == 1"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >{{ parseFloat(item.subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-else-if="field.item_prop.label.amt.show"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >{{ parseFloat(item.inv_price_with_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of Fifth Block -->
          <!-- Sixth Block -->
          <!-- Subtotal,total -->
          <!-- Tax,Discount -->
          <!-- Balance Due -->
          <div
            v-if="field.total_prop.label.show_total_sec"
            class="invoice-sixth-block"
            style="display: flow-root;"
            :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
          >
           <table
              v-if="field.total_prop.label.sub_total.show&& field.total_prop.label.show_total_qty"
              class="custom-invoice-total-table float-left"
           style="width:40%;word-break:break-word;border-collapse: collapse !important;"
            >
              <tbody>
                <tr>
                  <td>
                    <span
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      v-if="field.total_prop.label.show_total_qty"
                    >{{field.total_prop.label.item_in_total}} :</span>
                    <span
                      :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >{{list.invoice_header_detail.total_qty}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="custom-invoice-total-table float-right" style="width:60%;margin-top:0.25rem;margin-bottom:0.25rem;border-collapse: collapse !important;word-break:break-word">
              <tbody>
                <tr v-if="field.total_prop.label.sub_total.show">
                  <td
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    class="semi-bold"
                  >
                 
                  <span class="float-right">{{field.total_prop.label.sub_total.label+(list.invoice_header_detail.tax_type_id == 1?'(Tax Inclusive)':'')}}</span></td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    v-if="list.invoice_header_detail.tax_type_id == 1 && list.invoice_header_detail.discount_cat == 1"
                  >{{ parseFloat(parseFloat(list.invoice_header_detail.grand_total) - parseFloat(list.invoice_header_detail.adjusted_amount)).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    v-else-if="list.invoice_header_detail.tax_type_id == 2 && list.invoice_header_detail.discount_cat == 1"
                  >{{ parseFloat(list.invoice_header_detail.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    v-else-if="list.invoice_header_detail.discount_cat != 1"
                  >{{ parseFloat(list.invoice_header_detail.total_price_with_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
                <template
                  v-if="list.invoice_header_detail.discount_cat == 3 && list.invoice_header_detail.is_tax_reverse_charge == 0"
                >
                  <tr v-for="taxlist in splitted_tax" v-if="taxlist != null" :key="taxlist.id">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >{{ taxlist[0].label+' on '+taxlist[0].taxable }}</td>
                    <td
                    style="width:150px;padding-right: 8px !important"
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </template>
                <tr v-if="field.total_prop.label.show_discount">
                  <td
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >Discount</td>
                  <td
                  style="width:150px;padding-right: 8px !important"
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{'(-) ' + parseFloat(list.invoice_header_detail.inv_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
                 <tr v-if="field.total_prop.label.hasOwnProperty('total_tax_amt')&&field.total_prop.label.total_tax_amt.show">
                  <td
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    
                  >{{field.total_prop.label.total_tax_amt.label}}</td>
                  <td
                    class="text-right"
                    style="width:150px;padding-right: 8px !important"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{orgCurrencySymbol}}</span> {{parseFloat(list.invoice_header_detail.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}</td>
                </tr>
                <template
                  v-if="list.invoice_header_detail.discount_cat != 3 && list.invoice_header_detail.is_tax_reverse_charge == 0"
                >
                  <tr v-for="taxlist in splitted_tax" v-if="taxlist != null" :key="taxlist.id">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >{{ taxlist[0].label+' on '+taxlist[0].taxable }}</td>
                    <td
                    style="width:150px;padding-right: 8px !important"
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </template>
                <tr
                  v-if="field.total_prop.label.show_pay_detail&&list.invoice_header_detail.shipping_amount > 0&&list.invoice_header_detail.is_shipping_charge&&field.total_prop.label.shipping_charge  "
                >
                  <td
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{field.total_prop.label.shipping_charge}}</td>
                  <td
                  style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.invoice_header_detail.shipping_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
                <tr v-if="field.total_prop.label.show_pay_detail&&list.invoice_header_detail.adjusted_amount != 0 ">
                  <td
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{list.invoice_header_detail.adjustment_name}}</td>
                  <td
                  style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.invoice_header_detail.adjusted_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
                <tr>
                      <template v-if="field.total_prop.label.show_pay_detail">
                  <td
                  style="word-break:break-word"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{field.total_prop.label.total}}</td>
                  <td
                  style="width:150px;word-break:break-word;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.invoice_header_detail.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      </template>
                   <template v-else>
                        <td
                      style="word-break:break-word"
                        class="text-right semi-bold"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"                      >{{field.total_prop.label.total}}</td>
                      <td
                      style="width:150px;word-break:break-word;padding-right: 8px !important"
                        class="text-right semi-bold"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"                      ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.invoice_header_detail.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                   </template>
                </tr>
                <template v-if="field.menu_id==1&&field.total_prop.label.show_pay_detail">
                  <tr
                    style="background:#fff !important;"
                    v-if="parseFloat(list.invoice_amount_detail.paid_amount) != 0"
                  >
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.pay_made}}</td>

                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important;color:#f55d5d!important"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ '(-) ' +parseFloat(list.invoice_amount_detail.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                   <tr
                  v-if="parseFloat(list.invoice_amount_detail.withheld_amount) != 0&&field.total_prop.label.amt_withheld  "
                >
                  <td
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{field.total_prop.label.amt_withheld}}</td>
                  <td
                  style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ '(-) ' +parseFloat(list.invoice_amount_detail.withheld_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
                  <tr
                    style="background:#fff !important;"
                    v-if="parseFloat(list.invoice_amount_detail.credits_applied_amount) != 0"
                  >
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.credits_apply}}</td>
                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important;color:#f55d5d!important"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ '(-) ' +parseFloat(list.invoice_amount_detail.credits_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                  <tr
                    style="background:#fff !important;"
                    v-if="parseFloat(list.invoice_amount_detail.writeoff_amount) > 0"
                  >
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.writeoff_amt_label}}</td>
                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important;color:#f55d5d!important"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ '(-) ' +parseFloat(list.invoice_amount_detail.writeoff_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                  <tr>
                    <td
                      style="font-style:italic;"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >{{field.total_prop.label.bal_due}}</td>
                    <td
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.invoice_amount_detail.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!-- End of sixth block -->

          <!-- Seventh Block -->
          <div class="invoice-seventh-block" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <div
             style="word-break:break-word"
              v-if="list.invoice_header_detail.is_tax_reverse_charge == 1"
              class="text-left semi-bold mt-1"
              
            >
              Amount of tax subject to Reverse charge:
              <span
                class="fw-semi-bold"
              ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(list.invoice_header_detail.inv_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
            </div>
            <div
              v-if="field.total_prop.label.show_amt_wrd"
              class="text-left semi-bold"
              style="word-break:break-word"
            >Total Amount (in words) : {{ total_in_words+" Only" }}</div>
            <div style="border-top:1px solid #ededed;margin-bottom:2px;"></div>
            <div class="text-right" :style="{'font-size':6+'pt'}">
              <i>E. & O.E</i>
            </div>
          </div>
          <!-- End of seventh block -->

          <!-- Eigth Block  -->
          <div class="invoice-eigth-block" style="display: flow-root;" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <div class="signature-block">
                <div class="float-left" v-if="field.footer_prop.signature.show">
                  <div   style="word-break:break-word" class="semi-bold text-right mb-2" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{field.footer_prop.signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem"  />
                  <div   style="word-break:break-word"
                    class="text-left"
                  >{{field.footer_prop.signature.name}}</div>
                </div>
                <div class="float-right" v-if="field.footer_prop.hasOwnProperty('add_signature')&&field.footer_prop.add_signature.show">
                  <div   style="word-break:break-word" class="semi-bold text-right mb-2" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{field.footer_prop.add_signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem"  />
                  <div   style="word-break:break-word"
                    class="text-left"
                  >{{field.footer_prop.add_signature.name}}</div>
                </div>
              </div>
          </div>
          <!--End of  Eigth Block  -->

          <!-- Ninth Block -->
          <div class="invoice-ninth-block" v-if="field.footer_prop.show_term_con" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <div
              class="terms-conditions"
              :style="{'font-size':field.footer_prop.term_font_size+'pt'}"
            >
              <div :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="semi-bold text-left"   style="word-break:break-word">{{field.footer_prop.term_label}}</div>
              <div 
                style="word-break: break-word;white-space:pre"
              >{{ list.invoice_header_detail.internal_notes }}</div>
            </div>
          </div>
          <!--End of Ninth Block -->
          <!-- Tenth Block -->
          <div class="invoice-tenth-block spreadsheet-layout-pad" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <div class="invoice-notes" style="word-break:break-word">
               <div class="text-center" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{field.footer_prop.note_label||''}}</div>
              <div
                :style="{'font-size':field.footer_prop.note_font_size+'pt'}"
                class="text-center"
                style="word-break: break-word;white-space:pre"
              >{{list.invoice_header_detail.cus_inv_notes}}</div>
              <template v-if="org_details.account_no != '' && org_details.account_no != null"></template>
            </div>
          </div>
          <!-- End of Tenth Block -->
        </div>
        <!-- Body End -->
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.footer_color.hex||'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { number_to_words } from "@/mixins/NumberToWords";
export default {
  props: ["list", "printlabel", "showprintlabel"],
  data() {
    return {
      total_in_words: "",
      imageSrc: "",
      tax_list: "",
      currency_symbol: "",
      splitted_tax: []
    };
  },
  methods: {
    getIndexValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][0][prop] == val) {
          hasMatch = i;

          break;
        }
      }
      return hasMatch;
    }
  },
  created() {
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.invoice_header_detail.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(
        this.list.invoice_header_detail.grand_total,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.invoice_header_detail.cus_currency,
          "currency_code_fraction"
        )
      );
    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
  },
  mounted() {
    //    customer currency symbol
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.invoice_header_detail.cus_currency,
      "currency_symbol"
    );
    var splitted_tax_percent = [];
    var tax_on_taxable_amount = [];
    this.splitted_tax = [];
    this.list.invoice_item_detail.reduce((total, value) => {
      var tax_id =
        !isNaN(value.inv_tax_id) && value.inv_tax_id != ""
          ? parseFloat(value.inv_tax_id)
          : 0;
      // <!-----------------------------------dynamic tax calculation based on tax group------------------------------------------>
      if (!isNaN(tax_id) && tax_id != 0) {
        var tax_ids = value.tax_ids ? value.tax_ids.split(",") : "";

        if (tax_ids != "" && tax_ids != null && typeof tax_ids != "undefined") {
          for (var i = 0; i < tax_ids.length; i++) {
            if (
              this.list.tax_list[value.inv_itm_id][i].tax_amount != null &&
              typeof this.list.tax_list[value.inv_itm_id][i].tax_amount !=
                "undefined" &&
              !isNaN(this.list.tax_list[value.inv_itm_id][i].tax_amount)
            ) {
              splitted_tax_percent[tax_ids[i]] = !isNaN(
                splitted_tax_percent[tax_ids[i]]
              )
                ? parseFloat(splitted_tax_percent[tax_ids[i]]) +
                  parseFloat(this.list.tax_list[value.inv_itm_id][i].tax_amount)
                : parseFloat(
                    this.list.tax_list[value.inv_itm_id][i].tax_amount
                  );
              tax_on_taxable_amount[tax_ids[i]] = !isNaN(
                tax_on_taxable_amount[tax_ids[i]]
              )
                ? parseFloat(tax_on_taxable_amount[tax_ids[i]]) +
                  parseFloat(value.subtotal_without_tax)
                : parseFloat(value.subtotal_without_tax);
            }
            //  update splitted tax variable
            var hasMatch = this.getIndexValue(
              this.splitted_tax,
              "id",
              tax_ids[i],
              ""
            );
            var tax_details = [
              {
                id: tax_ids[i],
                label:
                  this.list.tax_main[tax_ids[i]].tax_name +
                  "[" +
                  parseFloat(this.list.tax_list[value.inv_itm_id][i].value) +
                  "%]",
                value: splitted_tax_percent[tax_ids[i]],
                taxable: parseFloat(tax_on_taxable_amount[tax_ids[i]]).toFixed(
                  2
                )
              }
            ];
            if (!isNaN(parseInt(hasMatch))) {
              this.splitted_tax[hasMatch] = tax_details;
            } else {
              this.splitted_tax.push(tax_details);
            }
          }
        }
      }
      return;
    }, 0);
  },
  computed: {
    ...mapState({
      field: state =>
        state.permission.print_settings_details["Invoice"].template_list
    }),
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details", "orgCurrencySymbol","pdt_settings_details"])
  }
};
</script>



<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page {
  width: 21cm;
  min-height: fit-content;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page {
  width: 29.7cm;
  min-height: fit-content;
}
//A5 standard portrait
#a5-standard-portrait-page {
  width: 14.8cm;
  min-height: fit-content;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page {
  width: 21cm;
  min-height: fit-content;
}

#a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
</style>
